<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <div style="float:right;margin-right:50px;">
                <i class="el-icon-question"></i>如何填写？
                <a
                  href="javascript:;"
                  style="color:#b60205;text-decoration:underline"
                  @click="helpMe"
                >查看示意图</a>
              </div>

              <el-dialog
                :visible.sync="help_show"
                width="80%"
                append-to-body
                title="公益项目导入救助花名册示意图"
              >
                <img width="100%" src="../../../../assets/images/compro_export_help.png" alt />
              </el-dialog>
              <el-col :span="12">
                <div style="font-color">导入提示：</div>
                <el-button @click="getTemplate" style="margin-top:15px">下载救助花名册模板</el-button>
                <div class="padding font-color">日期格式：2020/1/1</div>
                <div class="padding font-color">系统支持Excel（仅支持xlsx文件）格式文件导入</div>
                <div class="padding font-color">Excel 最多支持导入 2000 行（含表头）。</div>
                <div class="padding font-color">请先选择项目和阶段，再进行导入~</div>
              </el-col>
              <el-col :span="12">
                <p style="color:red;margin-bottom:20px">请选择要导入的项目(必选)：</p>
                <el-select
                  v-model="data.project_id"
                  placeholder="请先选择项目"
                  clearable
                  @change="changePro"
                >
                  <el-option
                    :label="item.project_name"
                    :value="item.project_id"
                    v-for="item in projectList"
                    :key="item.project_id"
                  ></el-option>
                </el-select>

                <el-select v-model="data.report_id" placeholder="再选择阶段" clearable>
                  <el-option
                    :label="item.report_name"
                    :value="item.id"
                    v-for="item in stageList"
                    :key="item.id"
                  ></el-option>
                </el-select>

                <el-upload
                  ref="upload"
                  class="upload-demo"
                  :action="exportsUrl"
                  :before-upload="beforeUpload"
                  :headers="headerInfo"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :data="data"
                  multiple
                  :limit="1"
                  :disabled="data.report_id >0?false:true"
                  :on-success="handleSuccess"
                  :file-list="fileList"
                  :auto-upload="false"
                >
                  <el-button
                    size="medium"
                    type="primary"
                    style="margin-top:30px"
                    @click="clearFileList"
                  >选择文件</el-button>
                </el-upload>

                <el-button
                  size="medium"
                  type="primary"
                  @click="doExports"
                  style="margin:30px 0px"
                  :loading="loading"
                >{{loading?'导入中……':'开始导入'}}</el-button>
              </el-col>
              <div style="margin:15px 180px 20px 0px;float:right" v-if="exportResult">
                <span>导入结果：</span>
                <div v-if="failNum > 0">
                  失败数据
                  <span style="color:red">{{failNum}}</span>条
                  <el-button
                    size="mini"
                    type="primary"
                    v-if="failNum > 0"
                    @click="downFailLog"
                    style="margin-top:30px;margin-left:5px"
                  >下载错误日志</el-button>
                  <span style="color:red" v-if="failNum > 0">请根据提示修改错误记录，确认无误后上传该文件</span>
                </div>
                <div style="margin-top:15px">
                  成功导入
                  <span style="color:green">{{succNum}}</span>条
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import "@/components/Hospital/public/poster.less";
import Axios from "axios";
import myHead from "@/components/Hospital/public/head";
import centerHead from "@/components/Hospital/public/center_head";
import leftMenu from "@/components/Hospital/public/menu";
import footDiv from "@/components/Hospital/public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    return {
      help_show: false,
      headerInfo: { Authorization: sessionStorage.getItem("token") },
      projectList: [],
      stageList: [], //阶段列表
      loading: false,

      temp_id: null,
      fileList: [], // 文件列表
      data: {
        project_id: null, //项目id
        report_id: null //阶段id
      }, // 文件数据
      exportResult: false,
      file: {},
      failNum: 0,
      succNum: 0,
      errorLog: null, // 错误日志保存的文件数据
      exportsUrl: "" //导入地址
    };
  },
  methods: {
    //示意图操作
    helpMe() {
      this.help_show = true;
    },

    beforeUpload(file) {
      this.exportResult = false;
      this.failNum = 0;
      this.succNum = 0;

      // 文件上传之前操作
      if (!file.name.includes(".xlsx")) {
        this.$message({
          showClose: true,
          message: "仅支持导入.xlsx的文件！",
          type: "warning"
        });
        this.loading = false;
        return false;
      }
    },
    doExports() {
      // 开始导入文件
      if (this.data.report_id == null) {
        this.$message({
          showClose: true,
          message: "请先选择项目阶段！",
          type: "error"
        });
        return false;
      }

      if (
        this.$refs.upload.uploadFiles &&
        this.$refs.upload.uploadFiles.length > 0
      ) {
      } else {
        this.$message({
          showClose: true,
          message: "请先选择上传的花名册！",
          type: "error"
        });
        return false;
      }

      this.loading = true;
      this.$refs.upload.submit();
    },
    handleSuccess(res, file, fileList) {
      this.loading = false;
      this.$refs.upload.clearFiles();

      if (res && res.code == 200) {
        this.failNum = 0;
        this.succNum = res.data.success;
        this.exportResult = true;
      } else {
        if (res.data && res.data.fail > 0) {
          this.exportResult = true;

          if (res.data.fail > 0) {
            this.errorLog = this.dataURLtoFile(res.data.file, "错误日志.xlsx"); // 存储错误日志
          }
          this.failNum = res.data.fail;
          this.succNum = res.data.success;
        } else {
          this.$message.warning(res.msg);
          this.exportResult = false;
        }
      }
    },
    downFailLog() {
      // 下载错误日志
      this.download(this.errorLog, "错误日志.xlsx");
    },
    clearFileList() {
      this.fileList = []; // 导入之前清空之前的文件列表
    },
    dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1], // 拿到文件的类型
        bstr = atob(arr[1]), // atob方法将base64字符串转换为binary文件流数据
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n); // 将文件流转换成Unicode编码 返回值是0 - 65535之间的整数。
      }
      return new File([u8arr], filename, { type: mime }); // 第一个参数是转换好的Unicode编码
    },

    //获取项目列表
    getProList() {
      this.$db.post(this.$db.config.getComProListForApply, {}).then(resp => {
        if (resp && resp.code == 200) {
          this.projectList = resp.data;
        }
      });
    },

    changePro(val) {
      //根据立项id获取阶段列表
      this.exportResult = false;
      this.data.report_id = null;
      this.loading = false;
      this.errorLog = null;
      this.failNum = null;
      this.succNum = null;
      this.stageList = [];
      if (val) {
        this.$db
          .post(this.$db.config.getStageListByProId, { id: val })
          .then(resp => {
            if (resp && resp.code == 200) {
              this.stageList = resp.data;
            }
          });
      }
    },

    // down() {
    //   let title = "上报申请.xlsx";
    //   this.$db.downFilePost("report-getReportApplyTemplate").then(res => {
    //     if (res.hasOwnProperty("code")) {
    //       var enc = new TextDecoder("utf-8");
    //       var result = JSON.parse(enc.decode(new Uint8Array(res)));
    //       if (result.code !== 200) {
    //         this.$Message.warning(result.msg);
    //       }
    //     } else {
    //       this.download(res, title);
    //     }
    //   });
    // },
    download(data, name) {
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ("download" in document.createElement("a")) {
        //支持a标签download的浏览器
        const link = document.createElement("a"); //创建a标签
        link.download = name; //a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(data);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      }
    },

    getTemplate() {
      return Axios.request({
        url: baseUrl + this.$db.config.getComProApplyTemplate,
        method: "post",
        responseType: "arraybuffer"
      }).then(res => {
        const content = res.data;
        const blob = new Blob([content]); //构造一个blob对象来处理数据
        const fileName = "救助花名册模板.xlsx";
        this.download(blob, fileName);
      });
    }

    //获取救助花名册模板
    // getTemplate() {
    //   // let title = "救助花名册.xlsx";
    //   this.$db
    //     .downFilePost(this.$db.config.getComProApplyTemplate)
    //     .then(res => {
    //       console.log(res,11111);

    //       const content = res.data;
    //       const blob = new Blob([content]); //构造一个blob对象来处理数据
    //       const fileName = "111.xlsx";

    //       //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
    //       //IE10以上支持blob但是依然不支持download
    //       if ("download" in document.createElement("a")) {
    //         //支持a标签download的浏览器
    //         const link = document.createElement("a"); //创建a标签
    //         link.download = fileName; //a标签添加属性
    //         link.style.display = "none";
    //         link.href = URL.createObjectURL(blob);
    //         document.body.appendChild(link);
    //         link.click(); //执行下载
    //         URL.revokeObjectURL(link.href); //释放url
    //         document.body.removeChild(link); //释放标签
    //       }
    //     });
    // }
  },
  mounted() {
    this.exportsUrl = baseUrl + this.$db.config.comProApplyExport;
    this.getProList();
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    // max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .padding {
    padding: 8px 0;
  }
  .font-color {
    color: #606266;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/apply/export.vue